import goodalipi from 'src/plugins/goodalipi'

const commonService = {
  getAuthToken() {
    let user = goodalipi.get('user')
    return user && user.accessToken ? user.accessToken.access_token : ''
  },

  getEntityID() {
    let user = goodalipi.get('user');
    return user.baseProfileData?.entityId;
  },

  getEntityKey() {
    let user = goodalipi.get('user');
    return user?.entityKey;
  }
}

export default commonService